module.exports = __webpack_public_path__ + "media/images/HubbleIQ_white-c1d631c89e8c4f915e4cfae6705a7d52.png";